import { dropdownMapping, updateRequest } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../../common/constant";
import { fetchAllPostPromisedData, fetchAllPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { useEffect, useState } from "react";


export const getDropdowns = async () => {
    const resp = await Promise.all([
      dropdownMapping(
        endpoint.country.getAllActive,
        "countryDesc",
        "countryCode",
      ),
      fetchAllPostPromisedData(
        `${endpoint.bankMaster.search}?offset=-1`,
        {}
      )

    ]);

    const bankList = resp[1]?.data?.bankMasterList ?? [];
    return {
      allCountries: resp[0],
      allBanks: bankList?.map(bank => ({...bank, label : bank?.bankName, value : bank?.id})),
    };
  
}

export const bankAccountTypes = [
    {label : 'Savings', value : 'Savings'},
    {label : 'Current', value : 'Current'},
]

export const userTypes = [
    {label : 'Primary', value : 'Primary'},
    {label : 'Secondary', value : 'Secondary'},
]

export const getAllBankAccountsByPsid = psid => {
    return fetchAllPromisedData(`${endpoint.studentBankDetails.getBankDetailsByPsid}/${psid}`);
}

export const useGetDropdownData = (setLoading) => {
    const [dropdownData, setDropdownData] = useState({});

    
        useEffect(() => {
            (async () => {
                try {
                    setLoading(true);
                    const dropdowns = await getDropdowns();
                    setDropdownData(dropdowns);
    
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            })();
        }, []);

        return {dropdownData}
    

}

export const addEditBankDetails = form => {
    const {id , bank} = form;
    let url = endpoint.studentBankDetails.create , method = 'post';

    if(id){
        url = `${endpoint.studentBankDetails.update}/${id}`;
        method = 'put';
    }

    const updatedForm = {
        ...form,
        bankMasterId : bank?.id,
        bankKey : bank?.bankId
    }

    const req = updateRequest(updatedForm);
    return fetchAllPostPromisedData(url, req, method);

}

export const EMPTY_FORM = {
    id : null,
    bank : "",
    country : "",
    accountNumber : "",
    accountType : "",
    bankAccountType : "",
    ifscCode : "",
    beneficiaryName : "",
    bankStatus : "ACTIVE",
    attachmentKey : "",
    beneficiaryBranch : "",
    studentRelation : ""
}

export const bankStatusChipInfo = {
    "ACTIVE" : {text : 'Active' , txtColor : "#05945B", bgColor : "#E6F4ED"},
    "INACTIVE" : {text : 'Inactive' , txtColor : "#757575", bgColor : "#F5F5F5"},
}

export const bankStatusChipStyle = {
  fontWeight: 600,
  padding: "4px 11px",
  borderRadius: "8px",
  fontSize: "12px",
  lineHeight: "16px"
};

export const beneficiaryTypeChipStyles = {
    ...bankStatusChipStyle,
    color : '#00B0F5',
    backgroundColor : '#E5F6FF'
}

export const studentRelationDropdown = [
    {label : 'Brother' , value : 'BRTH'},
    {label : 'Father' , value : 'FATH'},
    {label : 'Mother' , value : 'MOTH'},
    {label : 'Others' , value : 'OTHR'},
    {label : 'Sister' , value : 'SIST'},
    {label : 'Self' , value : 'SELF'},
]
